import React, { Component, PropTypes } from 'react';
import { Units } from 'Css';

const css = oxygenCss({
  root: {
    lineHeight: '46px',
    fontSize: 24,
    fontWeight: 400,
    letterSpacing: '0.5px',
    padding: `0 ${Units.base}px`,
    margin: 0
  }
});

class ToolbarTitle extends Component {
  static propTypes = {
    children: PropTypes.node,
    color: PropTypes.string
  };

  render() {
    const { children, color, ...other } = this.props;
    const style = color ? { color } : null;
    return (
      <h2 className={css.root} style={style}>
        {children}
      </h2>
    );
  }
}

export default ToolbarTitle;



// WEBPACK FOOTER //
// ./src/js/Cio/Toolbar/ToolbarTitle.js